import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import '../mystyle.css'
const Header = ({ cart , removeFromCart }) => {
    return (
<>
<header style={{background:'#4a2b96'}} className="navigation fixed-top">
  <nav className="navbar navbar-expand-lg navbar-dark">
    <a className="navbar-brand font-tertiary h3" href="index.html"><img src="/images/logo.png" alt="Myself"/></a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navigation"
      aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse text-center" id="navigation">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item active">
          <Link className="nav-link" to='/home'>Home</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to='/about'>About</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to='/films'>Films</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to='/categories'>Categories</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to='/contact'>Contact</Link>
        </li>
        <li>
          <Link className='nav-link'><i data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" className="bi bi-cart-fill cards"></i> {cart.length}</Link>
        </li>
      </ul>
    </div>
  </nav>
</header>
<div
  className="offcanvas offcanvas-start"
  data-bs-scroll="true"
  data-bs-backdrop="false"
  tabIndex={-1}
  id="offcanvasScrolling"
  aria-labelledby="offcanvasScrollingLabel"
  style={{fontFamily:'sans-serif',transition:'0.3s'}}
>
  <div className="offcanvas-header">
    <h5 style={{fontFamily:'sans-serif',transition:'0.3s'}} className="offcanvas-title" id="offcanvasScrollingLabel">
      Your Cart
    </h5>
    <button
      type="button"
      className="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    />
  </div>
  <div className="offcanvas-body">
    {cart.map((film) => (
<Card key={film.id} film={film} removeFromCart={removeFromCart} />
))}
  </div>
</div>

</>
    );
}

export default Header;
